export const truncateTitle = (title = '', maxLength = 24) => {
  const text = String(title || '').trim();
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1)}…`;
};
